const initialState = {
  menuActive: 'home',
  hideMenu: false
}

function reduceMenu(state = initialState, action) {

  switch (action.type) {
    case "MENU":
      let newState;
      if (state.menuActive !== action.menuActive) {
        newState = {
          menuActive: action.menuActive,
          hideMenu: action.hideMenu
        };
      } else {
        newState = state;
      }
      return newState || state;

    default:
      return state;
  }

}

export default reduceMenu;